var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-photo"},[_c('div',{staticClass:"team-photo__image",style:(`background-image: url('${this.image}');`)}),_c('span',{staticClass:"team-photo__name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }